import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IListState, PaginationType } from '@typings/requestPayloads'
export interface IListQueryPaginationPayload {
    pagination?: PaginationType
    query?: any
    needPopulate?: boolean
    necessaryProjectionArray?: string[]
    populates?: any[]
    sagaCB?: {
        onSuccess: any
    }
}

const initialState: IListState = {
    status: STATUS.IDLE,
    data: [],
    pagination: {
        skip: 0,
        hasTotal: true,
        total: 0,
        limit: 10
    },
    errors: null
}

const listSlice = createSlice({
    name: 'subscription/transactions-list',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IListQueryPaginationPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload.data
            state.pagination = {
                ...state.pagination,
                skip: action.payload.skip,
                total: action.payload.total
            }
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        },
        onChangeRecord(state, action) {
            const newData = [...state.data]
            const record = newData.find(item => item._id === action.payload.id)
            if (record) {
                record[action.payload.key] = action.payload.value
            }
            state.data = newData
        }
    }
})

export const listActions = listSlice.actions
export default listSlice.reducer
